import { useRoute } from 'vue-router'

import { DEFAULT_CLIDS } from '@/constants/general'
import {
    CLID_PARAM,
    GAME_DISTRIBUTION_GAME_ID_PARAM,
    GAME_ID_PARAM,
    GAME_PAYLOAD_PARAM,
    GAME_PLATFORM_PARAM,
} from '@/router/query-params'
import { useAppStore } from '@/store/app-store'
import type { APIGameType } from '@/types'
import safeURLParse from '@/utils/safeURLParse'

const GAME_IFRAME_QUERY_PARAMS_BLACKLIST = new Set([
    GAME_PLATFORM_PARAM,
    GAME_PAYLOAD_PARAM,
    GAME_DISTRIBUTION_GAME_ID_PARAM,
])

export function useGameIframeUrl() {
    const route = useRoute()
    const appStore = useAppStore()

    function buildGameIframeUrl(game: APIGameType): URL | null {
        const url = safeURLParse(game.game_url)

        if (!url) {
            return null
        }

        if (url.hostname.endsWith('games.playgama.com')) {
            url.hostname = url.hostname.replace('games.playgama.com', 'games.playgama.net')
        }

        if (appStore.clid && !Object.values(DEFAULT_CLIDS).includes(appStore.clid)) {
            url.searchParams.set(CLID_PARAM, appStore.clid as string)
        }

        if (game.source === 'playgama') {
            url.searchParams.set(GAME_ID_PARAM, game.id)

            // for games hosted on 3d party servers (like "hero wars") do pass all query params
            // it helps to segment audience on those games
            if (!url.hostname.endsWith('games.playgama.net')) {
                for (const [key, value] of Object.entries(route.query)) {
                    if (GAME_IFRAME_QUERY_PARAMS_BLACKLIST.has(key)) {
                        continue
                    }

                    const strValue = typeof value === 'string' ? value : ''
                    if (strValue) {
                        url.searchParams.set(key, strValue)
                    }
                }
            }
        }

        return url
    }

    return { buildGameIframeUrl }
}
